// let params
// if (typeof document !== 'undefined') {
//   params = new URLSearchParams(document.location.search)
// }

// const isPreviewMode = () => {
//   return process.env.NODE_ENV === 'development'
// }

export const useRegionSwitcherRedesign = true

export const useContentfulNav = true
